import { render, staticRenderFns } from "./applyAfterSales.vue?vue&type=template&id=67e80480&scoped=true&"
import script from "./applyAfterSales.vue?vue&type=script&lang=js&"
export * from "./applyAfterSales.vue?vue&type=script&lang=js&"
import style0 from "./applyAfterSales.vue?vue&type=style&index=0&id=67e80480&prod&scoped=true&lang=css&"
import style1 from "./applyAfterSales.vue?vue&type=style&index=1&id=67e80480&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e80480",
  null
  
)

export default component.exports